import { Injectable } from '@angular/core';
// import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(private snackBar: MatSnackBar
  ) {
  }
  success(message: string, panelClass: string = 'success-mssg', duration: number = 3000) {
    this.show(message, panelClass, duration);
  }

  error(message: string, panelClass: string = 'error-mssg', duration: number = 3000) {
    this.show(message, panelClass, duration);
  }

  info(message: string, panelClass: string = 'info-mssg', duration: number = 3000) {
    this.show(message, panelClass, duration);
  }

  warning(message: string, panelClass: string = 'warning-mssg', duration: number = 3000) {
    this.show(message, panelClass, duration);
  }

  private show(message: string, panelClass: string, duration: number) {
    const config = new MatSnackBarConfig();
    config.panelClass = [panelClass];
    config.duration = duration;
    config.data = { message };
    config.announcementMessage = message;
    config.horizontalPosition = this.horizontalPosition;
    config.verticalPosition = this.verticalPosition;
    this.snackBar.open(message, 'x', config)
      .onAction().subscribe(() => {
        this.dismiss();
      });
  }

  dismiss() {
    this.snackBar.dismiss();
  }

}
